<template>
  <a-tooltip v-if="statusDetails" :trigger="['hover', 'focus']" placement="top">
    <template slot="title">{{ statusDetails.description }}</template>
    <span class="stripe-payment-status" tabindex="0" :aria-label="accessibleLabel">
      <stripe-status-tag :label="`Stripe · ${statusDetails.label}`" :tone="statusDetails.tone">
        <a-icon
          class="stripe-payment-status__info-icon"
          width="16"
          height="16"
          icon="material-symbols:info-outline-rounded"
          aria-hidden="true"
        />
      </stripe-status-tag>
    </span>
  </a-tooltip>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
import { STRIPE_PAYMENT_STATUS } from '@/store/modules/payment/constants'
import StripeStatusTag from './stripe-status-tag.vue'

const UNKNOWN_STATUS = Object.freeze({
  label: 'Unknown',
  tone: 'neutral',
  description: 'Stripe returned a payment status that this version does not recognize.'
})

export default {
  components: {
    'a-tooltip': Tooltip,
    'stripe-status-tag': StripeStatusTag
  },
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    statusDetails() {
      if (!this.status) return null
      return STRIPE_PAYMENT_STATUS[this.status] || UNKNOWN_STATUS
    },
    accessibleLabel() {
      if (!this.statusDetails) return ''
      return `Stripe status: ${this.statusDetails.label}. ${this.statusDetails.description}`
    }
  }
}
</script>

<style scoped>
.stripe-payment-status {
  display: inline-flex;
  max-width: 100%;
}

.stripe-payment-status:focus-visible {
  border-radius: 5px;
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.stripe-payment-status__info-icon {
  flex: 0 0 auto;
}
</style>
